if (!customElements.get("m-ask-question")) {
  customElements.define(
    "m-ask-question",
    class MAskQuestion extends HTMLElement {
      constructor() {
        super()
        this.selectors = {
          openButton: '[data-open-ask-question]',
          content: '.m-form-ask-question',
          container: '.m-product-addon',
          formSuccess: '.form-ask__success'
        }
      }

      connectedCallback() {
        this.domNodes = queryDomNodes(this.selectors, this);
        this.container = document.querySelector(this.selectors.container);
        this.colorScheme = this.domNodes.content.dataset.colorScheme;
        if (this.domNodes.content && this.domNodes.content.innerHTML) {
          this.content = this.domNodes.content.innerHTML;
          this.init();
        }
      }

      init() {
        this.showSuccessMessage();
        this.modal = new MinimogTheme.Modal();
        const closeModal = this.modal.close;
        this.modal.close = (event) => {
          clearTimeout(this.focusTimer);
          closeModal(event);
          if (this.returnFocus?.isConnected) this.returnFocus.focus();
        };
        this.modal.modalContent.setAttribute('role', 'dialog');
        this.modal.modalContent.setAttribute('aria-modal', 'true');
        const closeButton = this.modal.modal.querySelector('.m-modal--close');
        closeButton.setAttribute('type', 'button');
        closeButton.setAttribute('aria-label', this.domNodes.content.dataset.closeLabel);
        this.modal.modal.addEventListener('keydown', (event) => {
          if (event.key !== 'Tab') return;
          const controls = Array.from(this.modal.modal.querySelectorAll('button:not([disabled]), input:not([disabled]):not([type="hidden"]), textarea:not([disabled]), select:not([disabled]), a[href]'))
            .filter((el) => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
          const first = controls[0];
          const last = controls[controls.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault(); last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault(); first.focus();
          }
        });
        addEventDelegate({
          selector: this.selectors.openButton,
          handler: (e) => {
            e.preventDefault()
            if (this.content) {
              const html = document.createElement("DIV");
              html.innerHTML = this.content;
              this.returnFocus = document.activeElement;
              // The source form stays hidden in the page. Give the displayed copy
              // its own IDs so labels resolve to the visible controls.
              html.querySelectorAll('[id]').forEach((el) => { el.id += '-dialog'; });
              html.querySelectorAll('label[for]').forEach((el) => {
                el.htmlFor += '-dialog';
              });
              this.modal.modalContent.setAttribute('aria-label', html.querySelector('h2').textContent.trim());
              this.modal.appendChild(html);
              this.modal.setWidth('500px');
              this.modal.setSizes(`m-form-ask-question m-gradient ${this.colorScheme}`);
              this.container.classList.remove('m\:hidden');
              this.modal.open();
              this.focusTimer = setTimeout(() => {
                if (this.modal.modal.isConnected) closeButton.focus();
              }, this.modal.transitionDuration + 20);
            }
          }
        })
      }
      showSuccessMessage() {
        const successMessage = this.container.querySelector(this.selectors.formSuccess);
        if (successMessage) {
          MinimogTheme.Notification.show({
            target: document.body,
            method: 'appendChild',
            type: 'success',
            message: successMessage.dataset.message,
            delay: 2000,
            sticky: true
          })

          setTimeout(() => {
            const url = window.location.origin + window.location.pathname
            window.history.replaceState({}, document.title, url)
          }, 2500)
        }
      }
    }
  );
}
